import React from 'react'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { Config } from '../../Config'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import './DisplaySettings.css'
import 'react-confirm-alert/src/react-confirm-alert.css'
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import { getDisplaySetting, SaveDisplaySetting } from '../../actions/displaysettings'
import 'rc-color-picker/assets/index.css'
import ColorPicker from 'rc-color-picker'
import ReactTooltip from 'react-tooltip'
import { Row, Col } from 'reactstrap'
import CommonService from '../Common/Functions';

class DisplaySettings extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      preferenceValues: {},
      currentLanguage: languageSettings.getCurrentLanguage(),
      saveSuccess: false,
      successMessage: '',
      errorMessages: '',
      isValid: false,
      GoalColorA: '',
      GoalColorB: '',
      GoalColorC: ''

    }
    this.common = new CommonService()
    this.timeFormatClick = this.timeFormatClick.bind(this)
    this.dashpullinsClick = this.dashpullinsClick.bind(this)
    this.storeColumnClick = this.storeColumnClick.bind(this)
    this.dashViewClick = this.dashViewClick.bind(this)
    this.handleSave = this.handleSave.bind(this)
    this.handleChangeMatric = this.handleChangeMatric.bind(this)
    this.handleChangeLanguage = this.handleChangeLanguage.bind(this)
    this.handleResetDefault = this.handleResetDefault.bind(this)
    this.changeHandlerGoalColorA = this.changeHandlerGoalColorA.bind(this)
    this.changeHandlerGoalColorB = this.changeHandlerGoalColorB.bind(this)
    this.changeHandlerGoalColorC = this.changeHandlerGoalColorC.bind(this)
    this.setPreferenceDashValues = this.setPreferenceDashValues.bind(this)
  }

  handleResetDefault (preferenceValues) {
    this.common.resetDefaultDisplaySettings(preferenceValues)
    let GoalColorA = '#00b04c'
    let GoalColorB = '#dcba00'
    let GoalColorC = '#b40000'
    if (this.props.page !== 'leaderboard') {
      this.common.getDefaultPreferenceDash(preferenceValues)
    }
    this.setPreferenceDashValues(preferenceValues)
    this.setState({ preferenceValues: preferenceValues, GoalColorA, GoalColorB, GoalColorC })
  }

  handleChangeLanguage (e) {
    let preferenceValues = this.state.preferenceValues
    preferenceValues.PreferenceLanguage = e.target.value
    this.setState({ preferenceValues })
  }

  handleChangeMatric (e) {
    let preferenceValues = this.state.preferenceValues
    preferenceValues.PreferenceDashMetric = e.target.value
    this.setState({ preferenceValues })
  }

  changeHandlerGoalColorA (colors) {
    this.setState({ GoalColorA: colors.color })
  }
  changeHandlerGoalColorB (colors) {
    this.setState({ GoalColorB: colors.color })
  }
  changeHandlerGoalColorC (colors) {
    this.setState({ GoalColorC: colors.color })
  }

  handleSave () {
    // const url = Config.apiBaseUrl + CommonConstants.apiUrls.saveDisplaySettings
    let data = this.state.preferenceValues

    data.PreferencePrimeColors = this.state.GoalColorA + '|' + this.state.GoalColorB + '|' + this.state.GoalColorC
    if (this.props.page === 'leaderboard') {
      this.props.leaderBoardSaveHandle(data)
    } else {
      this.props.SaveDisplaySetting(data, result => {
        if (result.status) {
          this.setState({ saveSuccess: true, successMessage: t[this.state.language]['Display Settings changes successful'] })
        }
      })
    }
  }

  timeFormatClick () {
    let preferenceValues = this.state.preferenceValues
    preferenceValues.TimeFormat = this.state.preferenceValues.TimeFormat === 'ss' ? 'mmss' : 'ss'
    this.setState({ preferenceValues })
  }

  dashpullinsClick () {
    let preferenceValues = this.state.preferenceValues
    preferenceValues.PreferenceDashPullins = this.state.preferenceValues.PreferenceDashPullins === '11' ? '4' : '11'
    this.setState({ preferenceValues })
  }

  setDefaultPreferenceDash (preferenceValues) {
    let preferenceDashObject = [
      {
        id: 't0',
        colOrder: ['StoreRank', 'Store', 'Store_Name', 'GoalA'],
        title: 'Stores'
      },
      {
        id: 't1',
        colOrder: ['t1Cars', 't1Avg', 't1Percent'],
        title: 'Current Day'
      },
      {
        id: 't2',
        colOrder: ['t2Cars', 't2Avg', 't2Percent'],
        title: 'Previous Day'
      }
    ]
    preferenceValues.PreferenceDash = JSON.stringify(preferenceDashObject)
    preferenceValues.PreferenceDashSort = 't1Avg | ASC'
    preferenceValues.DashboardOrder = 'Current|Day, Previous|Day'
    preferenceValues.PreferenceDashSortC = 't1Avg | ASC'
  }

  setPreferenceDashValues (preferenceValues) {
    if (preferenceValues.PreferenceDash) {
      let preferenceDashObject = JSON.parse(preferenceValues.PreferenceDash)
      if (preferenceDashObject !== null && preferenceDashObject.length > 0) {
        if (preferenceValues.PreferenceStoreColumnName === 'Include') {
          if (preferenceDashObject[0].colOrder.length === 4) {
            preferenceDashObject[0].colOrder.splice(2, 1, 'Store_Name')
          } else {
            preferenceDashObject[0].colOrder.splice(2, 0, 'Store_Name')
          }
        } else {
          if (preferenceDashObject[0].colOrder.length === 4) {
            preferenceDashObject[0].colOrder.splice(2, 1)
          }
        }
        preferenceValues.PreferenceDash = JSON.stringify(preferenceDashObject)
      }
    }
  }

  storeColumnClick () {
    let preferenceValues = this.state.preferenceValues
    preferenceValues.PreferenceStoreColumnName = this.state.preferenceValues.PreferenceStoreColumnName === 'Exclude' ? 'Include' : 'Exclude'
    this.setPreferenceDashValues(preferenceValues)
    this.setState({ preferenceValues })
  }

  dashViewClick (e) {
    let preferenceValues = this.state.preferenceValues
    preferenceValues.PreferenceDefaultView = e.target.value
    this.setState({ preferenceValues })
  }

  componentDidMount () {
    this.props.getDisplaySetting()
  }

  componentWillReceiveProps (newProps) {
    let preferenceValues = {}
    if (this.props.page === 'leaderboard') {
      preferenceValues = this.props.leaderboardData
    } else {
      preferenceValues = newProps.displaySettings
    }
    if (preferenceValues.PreferencePrimeColors === undefined ||
      preferenceValues.PreferencePrimeColors === null) {
      this.handleResetDefault(preferenceValues)
    }

    let GoalColorA = preferenceValues.PreferencePrimeColors.split('|')[0]
    let GoalColorB = preferenceValues.PreferencePrimeColors.split('|')[1]
    let GoalColorC = preferenceValues.PreferencePrimeColors.split('|')[2]
    this.setState({
      preferenceValues: preferenceValues,
      GoalColorA: GoalColorA,
      GoalColorB: GoalColorB,
      GoalColorC: GoalColorC
    })
  }

  componentDidUpdate () {
    ReactTooltip.rebuild()
  }

  render () {
    let values = this.state.preferenceValues
    const language = this.state.currentLanguage
    const DashboardviewTips = () => {
      return (
        <div>
          <p>
            <span translate='' key='Select a default view for your'>{t[language]['Select a default view for your']}</span>
            <span className='blueText'>*</span>.
            <span translate='' key='This will be the view you'>{t[language]['This will be the view you']}</span><br />
          </p>
          <p className='whiteLine'>
            <span className='blueText'>* </span>
            <span className='whiteText'>
              <span translate='' key='You must first configure a customized'>{t[language]['You must first configure a customized']}</span>
            </span>
          </p>
        </div>
      )
    }

    const PrimaryGoalTips = () => {
      return (
        <p>
          <p>
            <span translate='' key='Select a custom goal color'>{t[language]['Select a custom goal color']}</span><span className='blueText'>*</span>.
            <span translate='' key='These colors will allow you to easily'>{t[language]['These colors will allow you to easily']}</span> <br />
          </p>
          <p className='whiteLine whiteLine_Pullin'><span className='blueText'>* </span><span className='whiteText'>
            <span translate='' key='You can also manually enter the hexadecimal'>{t[language]['You can also manually enter the hexadecimal']}</span> </span>
          </p>
        </p>)
    }

    const TimeFormatTips = () => {
      return (
        <p>
          <p>
            <span translate='' key='Select the default time format'>{t[language]['Select the default time format']}</span><span className='blueText'>*</span>
            <span translate='' key='that will be shown on your'>{t[language]['that will be shown on your']}</span> <br />
          </p>
          <p className='whiteLine whiteLine_Pullin'><span className='blueText'>* </span><span className='whiteText'>
            <span translate='' key='Time format may be shown in minutes:seconds'>{t[language]['Time format may be shown in minutes:seconds']}</span></span></p>
        </p>
      )
    }

    const LanguageToolTips = () => {
      return (<p><span translate='' key='changethelanguage'>{t[language].changethelanguage}</span></p>)
    }

    const PullinsTips = () => {
      return (
        <p>
          <p>
            <span translate='' key='For dashboards and reports'>{t[language]['For dashboards and reports']}</span><span className='blueText'>*</span>
            <span translate='' key='data or exclude it'>{t[language]['data or exclude it']}</span> <br />
          </p>
          <p className='whiteLine whiteLine_Pullin'><span className='blueText'>* </span><span className='whiteText'>
            <span translate='' key='A pull-in is a vehicle that entered'>{t[language]['A pull-in is a vehicle that entered']}</span></span>
          </p>
        </p>
      )
    }

    if (values != null && values.TimeFormat !== undefined) {
      return (
        <div style={this.props.style}>
          <div className={this.state.saveSuccess ? 'show' : 'hide'}>
            <div className='forms clear'>
              <div className='appr' >
                <h4 translate='' key='recordsaved'>{this.state.successMessage}</h4>
              </div>
            </div>
          </div>
          <div className={'forms dash_cont ' + (this.state.saveSuccess ? 'hide' : 'show')} >
            <div className={this.props.page === 'leaderboard' ? 'hide' : 'show'}>
              <h3 className='dash_head'>
                <span>{this.props.page === 'leaderboard' ? t[language].leaderboardsettings : t[language]['Display Settings']}</span>
                <button type='button' id='ds_reset' onClick={() => this.handleResetDefault(this.state.preferenceValues)}>{t[language].resettodefaults}</button>
              </h3>
            </div>
            <div className={this.props.page === 'leaderboard' ? 'hide' : 'show'}>
              <span className='fright'>
                <span >{t[language].Metrics}</span>
                <select onChange={this.handleChangeMatric}>
                  <option value='2000' selected={values.PreferenceDashMetric === '2000' ? 'selected' : ''}>{t[language].LaneTotal}</option>
                  <option value='2001' selected={values.PreferenceDashMetric === '2001' ? 'selected' : ''}>{t[language].LaneTotal2}</option>
                </select>
              </span>
              <h5 className='displaySettingsHeader'><span>{t[language]['Default Dashboard View']}</span>
                <a data-tip data-for='defaultDashView' ><span className='tip openTip'>?</span></a>
                <ReactTooltip id='defaultDashView' place='right' type='dark' effect='solid' className='tooltip viewTipCont tooltips toolTip_darker displaySettings_toolTip'>
                  {DashboardviewTips()}
                </ReactTooltip>
              </h5>
              <div className='dash_goals_cont dash_cont_padd'>
                <button type='button' value='Daypart' name='dash_view1' id='dash_view1' onClick={this.dashViewClick} className={'dash_view_btn dash_view_marg_lt animated ' + (values.PreferenceDefaultView === 'Daypart' ? 'active_view flipInX' : '')}>{t[language].daypart}</button>
                <button type='button' value='Day' name='dash_view2' id='dash_view2' onClick={this.dashViewClick} className={'dash_view_btn dash_view_marg_rt animated ' + (values.PreferenceDefaultView === 'Day' ? 'active_view flipInX' : '')}>{t[language].day}</button>
                <button type='button' value='Week' name='dash_view3' id='dash_view3' onClick={this.dashViewClick} className={'dash_view_btn dash_view_marg_lt animated ' + (values.PreferenceDefaultView === 'Week' ? 'active_view flipInX' : '')}>{t[language].week}</button>
                <button type='button' value='Month' name='dash_view4' id='dash_view4' onClick={this.dashViewClick} className={'dash_view_btn dash_view_marg_rt animated ' + (values.PreferenceDefaultView === 'Month' ? 'active_view flipInX' : '')}>{t[language].month}</button>
                <button type='button' value='Custom' onClick={this.dashViewClick} name='dash_view5' id='dash_view5' className={'dash_view_btn dash_view_marg_lt animated custom282 ' + (values.PreferenceDefaultView === 'Custom' ? 'active_view flipInX' : '') + (values.DashboardOrder && values.DashboardOrder != null ? '' : ' hidden')} >{t[language].custom}</button>
                <input type='hidden' value='Day' name='dash_default_view' id='dash_default_view' />
              </div>
            </div>
            <h5><span translate='' key='primarygoalcolors'>{t[language].primarygoalcolors}</span>
              <a data-tip data-for='primarygoalcolors'><span className='tip openTip'>?</span></a>
              <ReactTooltip id='primarygoalcolors' place='right' type='dark' effect='solid' className='tooltip viewTipCont tooltips toolTip_darker TimeFormatTips' >
                {PrimaryGoalTips()}
              </ReactTooltip>
            </h5>
            <div className='dash_goals_cont dash_cont_padd MetricsXS '>
              <div className='dash_goals colorXS'>
                <div className='input-group input-group-sm'>
                  <div className='input-group-prepend'>
                    <span className='input-group-text' id='inputGroup-sizing-sm'><strong>&lt;</strong> {t[language].minigoal} A: </span>
                  </div>
                  <input type='text' className='form-control colorpickerinput' value={this.state.GoalColorA} />
                  <div className='input-group-append'>
                    <ColorPicker color={this.state.GoalColorA} enableAlpha={false} mode='RGB' onChange={this.changeHandlerGoalColorA} placement='bottomLeft' />
                  </div>
                </div>

                <div className='input-group input-group-sm'>
                  <div className='input-group-prepend'>
                    <span className='input-group-text' id='inputGroup-sizing-sm'><strong>&lt;</strong> {t[language].minigoal} B: </span>
                  </div>
                  <input type='text' className='form-control colorpickerinput' value={this.state.GoalColorB} />
                  <div className='input-group-append'>
                    <ColorPicker color={this.state.GoalColorB} enableAlpha={false} onChange={this.changeHandlerGoalColorB} placement='bottomLeft' />
                  </div>
                </div>

                <div className='input-group input-group-sm'>
                  <div className='input-group-prepend'>
                    <span className='input-group-text' id='inputGroup-sizing-sm'><strong>&gt;</strong> {t[language].minigoal} B: </span>
                  </div>
                  <input type='text' className='form-control colorpickerinput' value={this.state.GoalColorC} />
                  <div className='input-group-append'>
                    <ColorPicker color={this.state.GoalColorC} enableAlpha={false} onChange={this.changeHandlerGoalColorC} placement='bottomLeft' />
                  </div>
                </div>
              </div>
            </div>
            <Row>
              <Col lg='4'>
                <h5><span>{t[language].timeformat}</span>
                  <a data-tip data-for='timeformattip'><span className='tip openTip'>?</span></a>
                  <ReactTooltip id='timeformattip' place='right' type='dark' effect='solid' className='tooltip viewTipCont tooltips toolTip_darker TimeFormatTips '>
                    {TimeFormatTips()}
                  </ReactTooltip>
                </h5>
                <div className='dash_goals_cont MetricsXS'>
                  <div className='input-group dash_option_toggle dash_toggle_tf PullinXS'>
                    <input type='button' id='dash_mmss' className={'dash_op_btn dash_op_one ' + (values.TimeFormat === 'mmss' ? 'active_format animated slideInRight' : '')} value={t[language].minutesseconds} translate='' key='minutesseconds' onClick={this.timeFormatClick} />
                    <input type='button' id='dash_ss' className={'dash_op_btn dash_op_two ' + (values.TimeFormat === 'ss' ? 'active_format animated slideInLeft' : '')} value={t[language].seconds} translate='' key='seconds' onClick={this.timeFormatClick} />
                  </div>
                </div>
              </Col>
              <Col lg='4' className={(this.props.page === 'leaderboard' && values.LeaderboardModeID === 2) ? 'show' : 'hide'}>
                <h5><span>{t[language].language}</span>
                  <a data-tip data-for='languagetip'><span className='tip openTip'>?</span></a>
                  <ReactTooltip id='languagetip' place='right' type='dark' effect='solid' className='tooltip viewTipCont tooltips toolTip_darker_Show Lanuage_tooltip'>
                    {LanguageToolTips()}
                  </ReactTooltip>
                </h5>
                <div className='dash_goals_cont MetricsXS'>
                  <select onChange={this.handleChangeLanguage} >
                    <option value='en' selected={values.PreferenceLanguage === 'en' ? 'selected' : ''}>English</option>
                    <option value='fr-CA' selected={values.PreferenceLanguage === 'fr-CA' ? 'selected' : ''}>French (Canada)</option>
                  </select>
                </div>
              </Col>
            </Row>

            <Row>
              <Col lg='4'>
                <h5><span translate='' key='Pullins'>{t[language].Pullins}</span>
                  <a data-tip data-for='pullintip'><span className='tip openTip'>?</span></a>
                  <ReactTooltip id='pullintip' place='right' type='dark' effect='solid' className='tooltip viewTipCont tooltips toolTip_darker_Show TimeFormatTips'>
                    {PullinsTips()}
                  </ReactTooltip>
                </h5>
                <div className='dash_goals_cont MetricsXS'>
                  <div className='input-group dash_option_toggle dash_toggle_tf PullinXS'>
                    <input type='button' id='dash_mmss' className={'dash_op_btn dash_op_one ' + (values.PreferenceDashPullins === '4' ? 'active_format animated slideInRight' : '')} value={t[language].include} translate='' key='include' onClick={this.dashpullinsClick} />
                    <input type='button' id='dash_ss' className={'dash_op_btn dash_op_two ' + (values.PreferenceDashPullins === '11' ? 'active_format animated slideInLeft' : '')} value={t[language].exclude} translate='' key='exclude' onClick={this.dashpullinsClick} />
                  </div>
                </div>
              </Col>
              <Col lg='4' className={(this.props.page === 'leaderboard' && values.LeaderboardModeID === 2) ? 'show' : 'hide'}>
                <h5><span>{t[language].Metrics}</span>
                  <a data-for='matricstip'><span className='tip openTip'>?</span></a>
                  <ReactTooltip id='matricstip' place='right' type='dark' effect='solid' className='tooltip viewTipCont tooltips' />
                </h5>
                <div className='dash_goals_cont MetricsXS'>
                  <select onChange={this.handleChangeMatric}>
                    <option value='1' selected={values.PreferenceDashMetric === '1' ? 'selected' : ''}>{t[language].LaneTotal}</option>
                    <option value='2' selected={values.PreferenceDashMetric === '2' ? 'selected' : ''}>{t[language].LaneTotal2}</option>
                  </select>
                </div>
              </Col>
            </Row>

            <div className={this.props.page === 'leaderboard' ? 'hide' : 'show'}>
              <h5><span translate='' key='StoreNameColumn'>{t[language].StoreNameColumn}</span></h5>
              <div className='dash_goals_cont'>

                <div className='input-group dash_option_toggle dash_toggle_tf'>
                  <input type='button' id='dash_mmss' className={'dash_op_btn dash_op_one ' + (values.PreferenceStoreColumnName === 'Include' ? 'active_format animated slideInRight' : '')} value={t[language].include} translate='' key='include' onClick={this.storeColumnClick} />
                  <input type='button' id='dash_ss' className={'dash_op_btn dash_op_two ' + (values.PreferenceStoreColumnName === 'Exclude' ? 'active_format animated slideInLeft' : '')} value={t[language].exclude} translate='' key='exclude' onClick={this.storeColumnClick} />
                </div>
              </div>
            </div>
            <button type='button' className='submit' onClick={this.handleSave}>{t[language].savechanges}</button>
            &nbsp;|&nbsp;<a className='cancel_butt' href={Config.coldFusionUrl} translate='' key='cancel'>{t[language].cancel}</a>
          </div>
        </div>
      )
    } else {
      return <div />
    }
  }
}

function mapStateToProps (state) {
  return {
    displaySettings: state.displaysetting.displaySettings
  }
}

function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getDisplaySetting,
      SaveDisplaySetting
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(DisplaySettings)



// WEBPACK FOOTER //
// ./src/components/Settings/DisplaySettings.js